import type { CustomerAccountsTranslations } from './types'

/**
 * Urdu translations for CustomerAccounts domain
 */
export const urTranslations: CustomerAccountsTranslations = {
  // Page/Section level
  title: 'کسٹمر اکاؤنٹس',
  subtitle: 'کسٹمر مالیاتی اکاؤنٹس اور کریڈٹ لمٹس کا انتظام کریں',

  // Actions specific to domain
  addCustomerAccount: 'کسٹمر اکاؤنٹ شامل کریں',
  editCustomerAccount: 'کسٹمر اکاؤنٹ میں ترمیم کریں',
  deleteCustomerAccount: 'کسٹمر اکاؤنٹ حذف کریں',

  // Search and filters
  searchPlaceholder: 'کسٹمر اکاؤنٹس تلاش کریں...',
  noItemsFound: 'کوئی کسٹمر اکاؤنٹ نہیں ملا',
  noItemsDescription: 'ابھی تک کوئی کسٹمر اکاؤنٹ نہیں بنایا گیا۔ شروع کرنے کے لیے اپنا پہلا اکاؤنٹ شامل کریں۔',
  addFirst: 'اپنا پہلا کسٹمر اکاؤنٹ شامل کریں',

  // Form section
  form: {
    name: 'اکاؤنٹ کا نام',
    namePlaceholder: 'اکاؤنٹ کا نام درج کریں',
    status: 'حالت',

    validation: {
      nameRequired: 'اکاؤنٹ کا نام درکار ہے',
    }
  },

  // Status and states specific to domain
  status: {
    active: 'فعال',
    inactive: 'غیر فعال',
    suspended: 'معطل',
    blocked: 'بلاک',
  },

  actions: {
    viewDetails: 'تفصیلات دیکھیں',
    activate: 'فعال کریں',
    suspend: 'معطل کریں',
    block: 'بلاک کریں',
    adjustCreditLimit: 'کریڈٹ لمٹ ایڈجسٹ کریں',
  },

  // Toast messages for domain operations
  messages: {
    createSuccess: 'کسٹمر اکاؤنٹ کامیابی سے بنایا گیا',
    updateSuccess: 'کسٹمر اکاؤنٹ کامیابی سے اپ ڈیٹ ہوا',
    deleteSuccess: 'کسٹمر اکاؤنٹ کامیابی سے حذف ہوا',
    deleteConfirm: 'کیا آپ واقعی اس کسٹمر اکاؤنٹ کو حذف کرنا چاہتے ہیں؟',
  },

  stats: {
    totalAccounts: 'کل اکاؤنٹس',
    totalCreditLimit: 'کل کریڈٹ',
    totalOutstanding: 'بقایا',
    totalOverdue: 'تاخیر شدہ',
    accountsLabel: 'اکاؤنٹس',
  },

  filters: {
    searchAccounts: 'اکاؤنٹس تلاش کریں...',
    status: 'حیثیت',
    paymentTerms: 'ادائیگی کی شرائط',
    channel: 'چینل',
  },

  channel: {
    b2b: 'B2B',
    ecommerce: 'ای کامرس',
  },

  paymentTerms: {
    cod: 'COD',
    prepaid: 'پیشگی',
    net_7: 'نیٹ 7',
    net_15: 'نیٹ 15',
    net_30: 'نیٹ 30',
    net_60: 'نیٹ 60',
    net_90: 'نیٹ 90',
    custom: 'کسٹم',
  },

  labels: {
    creditLimit: 'کریڈٹ لمٹ',
    currentBalance: 'بیلنس',
    availableCredit: 'دستیاب',
    overdue: 'تاخیر شدہ',
    utilization: 'کریڈٹ استعمال',
    lastPayment: 'آخری ادائیگی',
    noPayments: 'ابھی تک کوئی ادائیگی نہیں',
    accountDetails: 'اکاؤنٹ کی تفصیلات',
    accountInfo: 'اکاؤنٹ کی معلومات',
    tenant: 'کسٹمر',
    paymentTerms: 'ادائیگی کی شرائط',
    vibanNumber: 'VIBAN نمبر',
    creditManagement: 'کریڈٹ مینجمنٹ',
    newCreditLimit: 'نئی کریڈٹ لمٹ',
    hasOverdue: 'تاخیر شدہ',
    notes: 'نوٹس',
  },

  // Table headers if applicable
  table: {
    account: 'اکاؤنٹ',
    tenant: 'کسٹمر',
    channel: 'چینل',
    paymentTerms: 'ادائیگی کی شرائط',
    creditLimit: 'کریڈٹ لمٹ',
    currentBalance: 'بیلنس',
    overdue: 'تاخیر شدہ',
    actions: 'اقدامات',
    name: 'نام',
    status: 'حالت',
  },

  view: {
    table: 'ٹیبل ویو',
    cards: 'کارڈ ویو',
  },

  empty: {
    noAccountsFound: 'کوئی اکاؤنٹ نہیں ملا',
  },

  cityAccess: {
    title: 'شہری رسائی',
    description: 'منتخب کریں کہ یہ اکاؤنٹ کن شہروں میں آرڈر دے سکتا ہے۔ تمام شہروں کی اجازت کے لیے خالی چھوڑ دیں۔',
    noCitiesAvailable: 'کوئی فعال شہر دستیاب نہیں',
    allCitiesAllowed: 'تمام شہر مجاز ہیں',
  },

  // Region access control
  regionAccess: 'علاقائی رسائی',
  regionAccessDescription: 'منتخب کریں کہ یہ اکاؤنٹ کن علاقوں میں ترسیل کر سکتا ہے۔ تمام علاقوں کی اجازت کے لیے خالی چھوڑ دیں۔',
  noRegionsAvailable: 'کوئی فعال علاقہ دستیاب نہیں',
  allRegionsAllowed: 'تمام علاقوں کی اجازت ہے',
}
